import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type ActivateUserCall = (token: string) => Promise<{ data: null }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<null>('POST', `${APIV2_URL}/action/activate`, {
    data: { token },
  });
